import React, { ReactNode } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom'; // Import Outlet for nested routes

import RealtorHeader from '../components/RealtorHeader';
import RealtorSidebar from '../components/RealtorSidebar';
import DashboardFooter from '../components/DashboardFooter';
import { Provider } from 'react-redux';
import store from '../../src/redux/store';
import { ToastContainer } from "react-toastify";
import { getAuthCookie, unauthenticatedLoginPath } from '../utils/authCookies';
// import "react-toastify/dist/ReactToastify.css";

type LayoutProps = {
  children?: ReactNode; // Children is optional since we are using Outlet
};

const RealtorLayout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  if (!getAuthCookie("sessionToken")) {
    return <Navigate to={unauthenticatedLoginPath(location.pathname, location.search)} replace />;
  }

  return (
    <Provider store={store}>
    <div id="layout-wrapper">
      <ToastContainer />
      {/* Header component */}
      <RealtorHeader />
      
      {/* Sidebar component */}
      <RealtorSidebar />

      {/* Main Content Area */}
      <div className="main-content me-0">
        <div className="page-content">
          <div className="container-fluid">
            {/* Outlet will render the matched child routes */}
            <Outlet />
          </div>
        </div>

        {/* Footer component */}
        <DashboardFooter />
      </div>
    </div>
    </Provider>
  );
};

export default RealtorLayout;
